// Search results list: click a row to place the plant; "+ Selection" attaches
// it to every selected element; ↗ opens the profile. Paginates via Load more.

import { esc, plantRowInner, profileLink, PLACE_HINT } from './html';

export function searchResultsHtml(hits, { total = null } = {}) {
  const rows = hits.map((h, i) => `
    <div class="pl2-result" data-pl2="place" data-idx="${i}" data-species-info="hit:${i}" data-species-hint="${PLACE_HINT}">
      ${plantRowInner(h)}
      <span class="pl2-result__actions">
        <button class="pl2-iconbtn" data-pl2="search-add-sel" data-idx="${i}" data-tip="Add to selected elements" aria-label="Add to selected elements">＋</button>
        <button class="pl2-iconbtn" data-pl2="search-add-el" data-idx="${i}" data-tip="Add to elements: click this, then click elements on the canvas" aria-label="Add to elements on the canvas">◎</button>
        ${profileLink(h.link)}
      </span>
    </div>`).join('');
  const more = total != null && hits.length < total
    ? `<button class="pl2-btn pl2-search-more" data-pl2="search-more">Load more (${hits.length} of ${total})</button>`
    : '';
  return rows + more;
}
